"use client";

import Translations from "@translate/components/DownAppModal";
import React, { useEffect, useState } from "react";
import { EdgenModal } from "@components/EdgenModal";
import { AssetImage, Icon } from "@ospweb/sdk-ui";
import { I18nUtil } from "@utils/i18n";
import { useIsPc } from "@hooks/useIsPc";
import { EdgenAppQRCode } from "@components/Home";
import { useSearchParams } from "next/navigation";
import { ANDROID_PLAY_STORE_URL } from "@config/nativeAppIdentity";

const I18n = I18nUtil.createScoped(Translations);

export function DownAppModal({}) {
  const [open, setOpen] = useState(false);
  const handleClose = () => {
    setOpen(false);
  };
  const query = useSearchParams();
  const from = (query.get("from") as string) || "en";
  useEffect(() => {
    if (from === "homesite") {
      setOpen(true);
    }
  }, [from]);
  const [isPc] = useIsPc();
  return (
    <>
      {/* PC：居中 Modal */}
      <EdgenModal
        open={open}
        onClose={handleClose}
        centered
        title={null}
        footer={null}
        closable={false}
        styles={{
          content: {
            padding: 0,
          },
        }}
        width={isPc ? 592 : "100%"}
        className={""}
        containerClassName="md:w-[592px] rounded-[12px] "
      >
        <div className="overflow-y-auto w-full h-full flex flex-col items-center justify-center bg-[#FEFFFA] rounded-[12px] pb-10">
          <AssetImage
            src="/close_new.svg"
            width={24}
            height={24}
            alt=""
            className="cursor-pointer w-6 h-6 object-cover absolute top-3 right-3"
            onClick={() => {
              handleClose();
            }}
          />

          <AssetImage
            src="/first_component_left_pic.webp"
            width={592}
            height={333}
            alt=""
            className="w-full h-full object-cover rounded-t-[12px]"
          />
          <div className="flex flex-col gap-4 text-center mt-10">
            <p className="headline_regular_l text-[#01262B] font-bold">
              {I18n.t("Download the app to get started.")}
            </p>
            <p className="body_l text-[#01262B]">
              {I18n.t(
                "Ed's latest features are built for mobile. Scan the QR code or tap below.",
              )}
            </p>
          </div>

          <div className="flex flex-row items-center justify-center gap-6 mt-8">
            <div className="rounded-3 bg-[#E6E8DC] p-2">
              <EdgenAppQRCode
                foregroundColor="#16141D"
                backgroundColor="#E6E8DC"
                size={144}
                className="bg-[#E6E8DC]"
              />
            </div>
            <div className="flex flex-col gap-[14px]">
              <AssetImage
                src="/appstore.svg"
                width={134}
                height={40}
                alt=""
                className="w-full h-full object-cover cursor-pointer"
                onClick={() => {
                  window.open(
                    "https://apps.apple.com/app/id6755764161",
                    "_blank",
                  );
                }}
              />
              <AssetImage
                src="/googleplay.svg"
                width={134}
                height={40}
                alt=""
                className="w-full h-full object-cover cursor-pointer"
                onClick={() => {
                  window.open(ANDROID_PLAY_STORE_URL, "_blank");
                }}
              />
            </div>
          </div>

          <p
            onClick={handleClose}
            className="button_m text-[#D97757] mt-8 cursor-pointer items-center justify-center flex gap-1"
          >
            {I18n.t("Continue on web")} <Icon name="right-arrow-alt" />
          </p>
        </div>
      </EdgenModal>
    </>
  );
}
